import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  mapcontainer: {
    position: "relative",
  },
}));

export default useStyles;
